import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "..";
import toast from "react-hot-toast";
import messages from "../../assets/Local/Local";

const initialState = {
  projectMembers: null,
  projectTasks: null,
  projectMembersLookup: null,
  projectProgress: 0,
  taskComments: null,
  downloadFileURL: null
};


export const getProjectMembers = createAsyncThunk(
  `task/getProjectMembers`,
  async (id) => {
    return await axiosInstance
      .get(`Projects/TeamMembers/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const addProjectMembers = createAsyncThunk(
  "agents/addAgent",
  async (data, { dispatch }) => {
    return await axiosInstance
      .put("Projects/UpdateManagers/" + data.projectId, data)
      .then((response) => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        dispatch(getProjectMembers(data.projectId));
        return response;
      })
      .catch((err) => {
        toast.error(err.response.data.error.message);
        return err;
      });
  }
);

export const getProjectTasks = createAsyncThunk(
  `task/getProjectTasks`,
  async (data) => {
    return await axiosInstance
      .get(`Projects/Tasks/${data.projectId}`, { params: data })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const addEditProjectTask = createAsyncThunk(
  `task/addEditProjectTask`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .post(`Projects/Tasks/Upsert/${data.projectServiceId}`, data)
      .then((response) => {
        dispatch(getProjectTasks({ projectId: data.projectId }));
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);
export const deleteProjectTask = createAsyncThunk(
  `task/deleteProjectTask`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .put(`Projects/DeleteTask/${data.taskId}`, data)
      .then((response) => {
        dispatch(getProjectTasks({ projectId: data.projectId }));
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const upsertTaskComments = createAsyncThunk(
  `task/upsertTaskComments`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .post(`UpsertTaskComments?projectTaskId=${data.taskId}`, data)
      .then((response) => {
        dispatch(getTaskComments({ taskId: data.taskId }));
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);
export const getTaskComments = createAsyncThunk(
  `task/getProjectTask`,
  async (data, { dispatch }) => {

    return await axiosInstance
      .get(`TaskComments?projectTaskId=${data.taskId}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const getTaskExcelFile = createAsyncThunk(
  "task/getTaskExcelFile",
  async () => {
    return await axiosInstance
      .get("/Get_TaskSampleExcelUrl")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        toast.error(err.response.data.error.message, {});

        return err;
      });
  }
);



const TaskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProjectMembers.fulfilled, (state, action) => {
      state.projectMembers = action.payload.data;
      state.projectMembersLookup = action.payload.data?.teamMembers?.map((item) => ({
        id: item.userId,
        name_en: item.fullName,
        name_ar: item.fullName,
      }));
    });
    builder.addCase(getProjectTasks.fulfilled, (state, action) => {
      state.projectTasks = action.payload.data.allProjectTasks;
      state.projectProgress = action.payload.data.projectProgress;
    });
    builder.addCase(getTaskComments.fulfilled, (state, action) => {
      state.taskComments = action.payload.data;
    });
    builder.addCase(getTaskExcelFile.fulfilled, (state, action) => {
      state.downloadFileURL = action.payload.data.data;
    });
  },
});

export const TaskReducer = TaskSlice.reducer;
